export const STATUS_SYNC_INFO = 'STATUS_SYNC_INFO';